// removed by extract-text-webpack-plugin
module.exports = {"vpCameraButtonsContainer":"vpCameraButtonsContainer___kMUgC","vpStartRecordingButton":"vpStartRecordingButton___3gPGp","vpStopRecordingButton":"vpStopRecordingButton___1xVeL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CameraRecord/CameraRecord.module.less
// module id = 3492
// module chunks = 33